// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".titletext{color:#333;text-align:center;font-size:14px}.divtitle{width:100%;height:40px;line-height:40px}.videoDiv{position:absolute;top:0;left:0;right:0;bottom:20px}.xuanchuanvideo{height:100%}.xuanchuanvideo .video-js{height:100%!important;padding-top:0}.xuanchuanvideo .video-js .vjs-big-play-button{width:46px;height:46px!important;border-radius:50%;position:absolute;left:0;right:0;bottom:0;top:0;margin:auto;background-color:rgba(43,51,63,.7)!important}", ""]);
// Exports
module.exports = exports;
